import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TopUpViewModel } from '../models/top-up-view.model';
import { CallBackModel } from '../models/callback.model';
import { ProviderUiActionResponse } from '../models/provider-ui-action-response.model';
import { PaymentService } from '../../shared/services/payment/payment.service';
import { ApiService } from '../../shared/services/core/api.service';
import { TopUpAmountTypeId } from '../models/topup-amount-type-id';
import { EcashTransferViewModel } from '../models/ecash-transfer-view-model';
import { TopupTicketStore } from '../../tickets/topup/topup-ticket.store';
import { tap } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({
  providedIn: 'root'
})
export class EcashService {
  constructor(
    private api: ApiService,
    private logService: LoggingService,
    private paymentService: PaymentService,
    private topupTicketStore: TopupTicketStore
  ) {}

  public getTopUpAmounts(topUpAmountId: TopUpAmountTypeId): Observable<number[]> {
    return this.api.getById<number[]>('topup/TopUpAmounts', topUpAmountId.toString()).pipe(
      // Convert returned values in pence to pounds
      tap(amounts => {
        this.topupTicketStore.setTopUpAmounts(amounts.map(amount => amount / 100));
      })
    );
  }

  public topUp(topUp: TopUpViewModel[]) {
    this.logService.debug('Making request for top up', topUp);
    this.api.post<TopUpViewModel[]>('topup/topup', topUp)
      .subscribe(response => this.paymentService.process(response, '', '/ecash/failure'));
  }

  public callBack(callback: CallBackModel): Observable<ProviderUiActionResponse> {
    this.logService.debug('Ecash callback received', callback);
    return this.api.post<CallBackModel>('topup/result', callback);
  }

  public transferEcash(data: EcashTransferViewModel) {
    this.logService.debug('Transferring ecash', data);
    return this.api.post('purse/transfer', data);
  }
}
